module.exports = __webpack_public_path__ + "img/seller-desktop.49852992.jpg";